function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14.252,
  height: 14.252,
  fill: "none"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "icon_close",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_145",
  "data-name": "Rectangle 145",
  width: 17.995,
  height: 2.159,
  transform: "translate(1.527) rotate(45)",
  fill: "#fb3e0d"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_146",
  "data-name": "Rectangle 146",
  width: 17.995,
  height: 2.159,
  transform: "translate(14.252 1.527) rotate(135)",
  fill: "#fb3e0d"
}));

function SvgUnpaid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.252,
    height: 14.252,
    viewBox: "0 0 14.252 14.252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpaid);
export default __webpack_public_path__ + "static/media/unpaid.4b78d308.svg";
export { ForwardRef as ReactComponent };